import { getItemSafe } from './localStorage'
import { Cookies } from './cookies'
import { appDomain } from '../config'

const REFERRAL_TOKEN_KEY = 'referralToken'
const VALIDITY_MS = 1000 * 60 * 60 * 24 * 90 // 90 days

const PAID_ADS_TRACKING_ARGS = ['fbclid', 'gclid', 'mkclkid', 'dclid'] // these search params are markers of following search engine / fb paid ads
function userComingFromPaidAd(params: URLSearchParams) {
  const paramsNames = params.keys()
  for (const paramName of paramsNames) {
    if (PAID_ADS_TRACKING_ARGS.includes(paramName)) {
      return true
    }
  }
  return false
}

export function saveReferralToken({
  now = Date.now(),
  search = window.location.search,
}: { now?: number; search?: string } = {}) {
  const params = new URLSearchParams(search)
  if (userComingFromPaidAd(params)) {
    return
  }
  let referralCode = null
  const gspk = params.get('gspk')
  const ucc = params.get('ucc')
  if (gspk) {
    referralCode = atob(gspk)
  } else if (ucc) {
    referralCode = ucc
  }

  if (referralCode) {
    document.cookie = `${REFERRAL_TOKEN_KEY}=${referralCode}; expires=${new Date(
      now + VALIDITY_MS
    ).toUTCString()}; path=/; domain=.${appDomain}; SameSite=Lax`
  }
}

export function getReferralToken() {
  // use value from cookie if available
  const cookie = Cookies.get(REFERRAL_TOKEN_KEY)
  if (cookie) {
    return cookie.value
  }

  // else resolve from localStorage
  const value = getItemSafe(REFERRAL_TOKEN_KEY)
  if (!value) {
    return null
  }
  try {
    const { token, date } = JSON.parse(value)
    if (Date.now() - VALIDITY_MS > new Date(date).getTime()) {
      return null
    }
    return token
  } catch (error) {
    // at some point the localStorage value was only a string, let's return it
    return value
  }
}

export function clearReferralToken() {
  document.cookie = `${REFERRAL_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; .domain=.${appDomain}; SameSite=Lax`
}
